import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { RouterDevtools } from '../components/devtools.tsx'
import { RouteError } from '../components/route-error.tsx'
import { Layout } from '../components/layout.tsx'
import { NotFound } from '../components/not-found.tsx'

/*
 * The root route, with its typed context.
 *
 * `queryClient` in the context is what lets a route's `beforeLoad` resolve `['me']` before
 * loading the component: it is the guard of §4.4/§5, and without a typed context every route
 * would have to import the client from a module, making it unreplaceable in tests.
 */

export interface RouterContext {
  readonly queryClient: QueryClient
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <Layout>
      <Outlet />
      {/* Inside the router's tree and not beside it: the devtools read the state with
          useRouterState, and outside the provider they take the app down. */}
      <RouterDevtools />
    </Layout>
  ),
  errorComponent: RouteError,
  notFoundComponent: NotFound,
})
